import React from 'react';
import { Form, Grid, Input, Modal, ModalProps, Typography } from '@arco-design/web-react';
import { useBindOtp, useGetOtp } from '@/hooks';
import { QRCodeSVG } from 'qrcode.react';

const { Row, Col } = Grid;
export const OptModal = ({ visible, onCancel }: ModalProps) => {
  const [form] = Form.useForm();
  const bindOtp = useBindOtp({
    config: {
      onSuccess: () => {
        onCancel && onCancel();
      },
    },
  });
  const { data, isLoading, isError } = useGetOtp({
    config: {
      enabled: visible,
    },
  });
  const onOk = async () => {
    try {
      const data = await form.validate();
      bindOtp.mutate(data);
    } catch (e) {
      console.dir(e);
    }
  };
  if (isLoading || isError) {
    return null;
  }
  return (
    <>
      <Modal
        title="绑定谷歌验证"
        alignCenter
        visible={visible}
        autoFocus
        onOk={onOk}
        confirmLoading={bindOtp.isLoading}
        focusLock
        unmountOnExit
        onCancel={() => {
          form.resetFields();
          onCancel && onCancel();
        }}
      >
        <Form layout="vertical" form={form}>
          <Row gutter={[20, 20]}>
            <Col span={24}>
              <div className="text-center flex flex-col items-center">
                <QRCodeSVG value={data.data} />
                <div className="bg-gray-100 px-2.5 pt-3  mt-4 w-[300px] rounded-md">
                  <Typography.Paragraph copyable>{data.data}</Typography.Paragraph>
                </div>
              </div>
            </Col>
            <Col span={24}>
              <Form.Item
                label="谷歌验证码"
                field="code"
                rules={[{ required: true, message: '请输入谷歌验证码' }]}
              >
                <Input placeholder="谷歌验证码" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
